import Reflux from 'reflux';

// eslint-disable-next-line no-unused-vars
let sync = { sync: true };
export default Reflux.createActions([
  'bindHotKeys',
  'unbindHotKeys',
  'bindFullScreenKeys',
  'unbindFullScreenKeys',
  'bindToggleFullScreenKeys',
  'unbindToggleFullScreenKeys',
  'bindNavigationKeys',
  'unbindNavigationKeys',
]);
